/* v32: înlocuiește emoji-urile din interfața temei cu iconițe SVG unitare (verdele site-ului). Descrierile produselor nu sunt atinse. */
(function () {
  var S = 'xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
  var IC = {
    ruler: '<svg ' + S + '><path d="M3 16.5 16.5 3 21 7.5 7.5 21z"/><path d="M7 12.5l1.5 1.5M10 9.5l1.5 1.5M13 6.5l1.5 1.5"/></svg>',
    truck: '<svg ' + S + '><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3.5V16h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>',
    box: '<svg ' + S + '><path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/></svg>',
    store: '<svg ' + S + '><path d="M4 9.5V20h16V9.5"/><path d="M3 9.5 4.5 4h15L21 9.5a2.5 2.5 0 0 1-4.5 1.4 2.5 2.5 0 0 1-4.5 0 2.5 2.5 0 0 1-4.5 0A2.5 2.5 0 0 1 3 9.5z"/><path d="M10 20v-5h4v5"/></svg>',
    fire: '<svg ' + S + '><path d="M12 21c-3.6 0-6-2.4-6-5.6 0-3.2 2.6-5.1 3.6-8.4.9 1.6 1.5 2.6 2.7 3.4.4-2.2 1.4-4.2 3-5.4.2 3 3 5.4 3 9.2C18.3 18.6 15.9 21 12 21z"/></svg>',
    dot: '<span class="msd-ic-dot"></span>'
  };
  // 🚚 / 📦 (livrare) și 🔥 („clienți folosesc”) rămân emoji, la cerere
  var MAP = [['🟢', 'dot'], ['📏', 'ruler'], ['🏬', 'store']];
  var ZONES = '.sg-trigger, .custom-stock-message, .product-stock, .product-hot-stock, .pg-store-icon, .msd-cdel__ic, .productView-details, .msd-col2, .productView-stickyCart';
  var SKIP = '.tab-content, .toggle-content, .msd-faq, .msd-specs, .msd-cmp, input, textarea, script, style';
  function swap(node) {
    var t = node.nodeValue, hit = null;
    for (var i = 0; i < MAP.length; i++) if (t.indexOf(MAP[i][0]) > -1) { hit = MAP[i]; break; }
    if (!hit) return;
    var p = node.parentNode;
    if (!p || (p.closest && p.closest(SKIP))) return;
    var idx = t.indexOf(hit[0]);
    var before = t.slice(0, idx), after = t.slice(idx + hit[0].length).replace(/^\uFE0F/, '');
    var ic = document.createElement('span');
    ic.className = 'msd-ic msd-ic--' + hit[1];
    ic.innerHTML = IC[hit[1]];
    var frag = document.createDocumentFragment();
    if (before) frag.appendChild(document.createTextNode(before));
    frag.appendChild(ic);
    var rest = document.createTextNode(after);
    frag.appendChild(rest);
    p.replaceChild(frag, node);
    swap(rest);
  }
  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    var zones = root.matches && root.matches(ZONES) ? [root] : [];
    zones = zones.concat([].slice.call(root.querySelectorAll(ZONES)));
    if (!zones.length && root.closest && root.closest(ZONES)) zones = [root];
    zones.forEach(function (z) {
      var w = document.createTreeWalker(z, NodeFilter.SHOW_TEXT), n, list = [];
      while ((n = w.nextNode())) if (/[\u{1F300}-\u{1FAFF}]/u.test(n.nodeValue)) list.push(n);
      list.forEach(swap);
    });
  }
  function start() {
    scan(document.body);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'characterData') { if (m.target.parentNode) scan(m.target.parentNode); }
        else m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); else if (n.nodeType === 3 && n.parentNode) scan(n.parentNode); });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
